<template>
  <!-- TODO - REPLACE WITH LOGO -->
  <div class="container" :class="size">
    <span class="ball" />
    <span class="ball" />
    <span class="ball" />
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: {
    size: {
      type: String,
      required: false,
      default: "small",
    },
  },
};
</script>

<style scoped lang="scss">
// TODO - FIGURE OUT SCSS VS POSTCSS AND BE CONSISTENT ACROSS APP
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60px;
  margin: 0 auto;
  flex-direction: row;
  &.small {
    width: 30px;
    .ball {
      width: 5px;
      height: 5px;
    }
  }
}

.ball {
  background-color: #ddd;
  border-radius: 50%;
  display: block;
  width: 10px;
  height: 10px;
  animation: jump 1.25s ease-in-out infinite;
}

.ball:nth-child(2) {
  animation-delay: 0.15s;
}

.ball:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes jump {
  0%,
  60% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-10px);
  }
}
</style>
